import React from 'react';
import { FaGithub, FaLinkedin, FaEnvelope, FaYoutube } from "react-icons/fa";

const SocialLinks = ({ isDarkMode = false, variant = 'default' }) => {
  // Social links data - updated with correct URLs
  const socialLinks = [
    {
      name: 'Email',
      icon: FaEnvelope,
      url: 'mailto:teymouri.saleh@gmail.com',
      color: 'text-red-500'
    },
    {
      name: 'LinkedIn',
      icon: FaLinkedin,
      url: 'https://www.linkedin.com/in/msteymouri',
      color: 'text-blue-500'
    },
    {
      name: 'GitHub',
      icon: FaGithub,
      url: 'https://www.github.com/saleh-teymouri',
      color: 'text-gray-500'
    },
    {
      name: 'YouTube',
      icon: FaYoutube,
      url: 'https://www.youtube.com/@Saleh_Teymouri',
      color: 'text-red-600'
    }
  ];

  // Different styling variants
  const getVariantStyles = () => {
    switch (variant) {
      case 'home':
        return {
          container: 'flex justify-center space-x-8 mt-6',
          link: 'text-white hover:text-indigo-400 transition-all duration-300 transform hover:scale-110',
          icon: 'h-8 w-8'
        };
      case 'footer':
        return {
          container: 'flex justify-center space-x-6',
          link: `transition-colors duration-300 ${
            isDarkMode
              ? 'text-gray-400 hover:text-gray-300'
              : 'text-gray-400 hover:text-gray-500'
          }`,
          icon: 'h-6 w-6'
        };
      default:
        return {
          container: 'flex justify-center space-x-6',
          link: 'text-gray-400 hover:text-gray-500 transition-colors duration-300',
          icon: 'h-6 w-6'
        };
    }
  };

  const styles = getVariantStyles();

  return (
    <div className={styles.container}>
      {socialLinks.map((social) => {
        const IconComponent = social.icon;
        return (
          <a
            key={social.name}
            href={social.url}
            target="_blank"
            rel="noopener noreferrer"
            className={styles.link}
            aria-label={social.name}
          >
            <IconComponent className={styles.icon} />
          </a>
        );
      })}
    </div>
  );
};

export default SocialLinks;
